import { makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const PayoffCardCellText = observer(({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="body1" style={{ lineHeight: '35px' }}>{children}</Typography>
  )
});